import { render, staticRenderFns } from "./VesselIssues.vue?vue&type=template&id=9418d858&scoped=true"
import script from "./VesselIssues.vue?vue&type=script&lang=js"
export * from "./VesselIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9418d858",
  null
  
)

export default component.exports